import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

const USER_KEY   = 'klemantina_admin_data';
const EXPIRY_KEY = 'klemantina_admin_expiry';

export interface AdminUser {
  adminUserID: number;
  email: string;
  firstName?: string;
  lastName?: string;
}

@Injectable({
  providedIn: 'root'
})
export class AdminAuthService {
  private currentAdminSubject = new BehaviorSubject<AdminUser | null>(null);
  public currentAdmin$ = this.currentAdminSubject.asObservable();

  constructor() {
    this.loadStoredAdmin();
  }

  private loadStoredAdmin(): void {
    if (!this.isAuthenticated()) return;

    const userData = localStorage.getItem(USER_KEY);
    if (userData) {
      try {
        const admin = JSON.parse(userData) as AdminUser;
        this.currentAdminSubject.next(admin);
      } catch {
        this.clearLocalState();
      }
    }
  }

  // expiresAt: Unix ms timestamp returned by the server in the verify-otp response
  setSession(admin: AdminUser, expiresAt: number): void {
    localStorage.setItem(USER_KEY,   JSON.stringify(admin));
    localStorage.setItem(EXPIRY_KEY, String(expiresAt));
    this.currentAdminSubject.next(admin);
  }

  isAuthenticated(): boolean {
    const expiry = Number(localStorage.getItem(EXPIRY_KEY));
    return !!expiry && Date.now() < expiry;
  }

  // Call after the logout API request clears the HttpOnly cookie server-side
  clearLocalState(): void {
    localStorage.removeItem(USER_KEY);
    localStorage.removeItem(EXPIRY_KEY);
    this.currentAdminSubject.next(null);
  }

  getCurrentAdmin(): AdminUser | null {
    return this.currentAdminSubject.value;
  }

  logout(): void {
    this.clearLocalState();
  }
}
